import { getVarsoUrl } from "../../../../common/helpers/helpers";

export const gerpUrl = getVarsoUrl(
  "http://mendel.stanford.edu/SidowLab/downloads/gerp/index.html"
);
export const dbnsfpUrl = getVarsoUrl(
  "https://sites.google.com/site/jpopgen/dbNSFP"
);
export const PhastCons100wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phastCons100way/"
);
export const PhastCons30wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phastCons30way/"
);
export const PhastCons20wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phastCons20way/"
);
export const PhastCons17wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phastCons17way/"
);
export const PhyloP100wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phyloP100way/"
);
export const PhyloP30wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phyloP30way/"
);
export const PhyloP20wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phyloP20way/"
);
export const PhyloP17wayUrl = getVarsoUrl(
  "http://hgdownload.soe.ucsc.edu/goldenPath/hg38/phyloP17way/"
);
export const fitConsUrl = "http://compgen.cshl.edu/fitCons/";
export const SiPhy29wayUrl = getVarsoUrl(
  "https://www.broadinstitute.org/mammals-models/29-mammals-project-supplementary-info"
);
export const mpcUrl = getVarsoUrl(
  "ftp://ftp.broadinstitute.org/pub/ExAC_release/release1/regional_missense_constraint/"
);
export const bstatisticUrl = getVarsoUrl("http://cadd.gs.washington.edu/");
